import Tabs from "@/components/Tabs";
import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import PageHeading from "@/components/PageHeading";
import { useNavigate } from "@/router";
import { useLocation } from "react-router-dom";
import { getDuesManagementNavLinks } from "../_utils";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const navLinks = getDuesManagementNavLinks();

  return (
    <AppLayout interior bottomBar navLinks={navLinks}>
      <Breadcrumb title="Dues Management" backLink={{ to: "/billing/dues-management" }} />
      <PageHeading title="Suspensions and Terminations" compact />
      <Tabs
        tabItems={[
          {
            label: "Eligible for Suspension",
            to: "/billing/dues-management/suspensions-and-terminations/suspensions" as const
          },
          {
            label: "Eligible for Termination",
            to: "/billing/dues-management/suspensions-and-terminations/terminations" as const
          }
        ].map(({ label, to }) => ({
          label,
          onClick: () => navigate(to),
          active: (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname) === to
        }))}
      />
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
